import { render } from "./enterprise-details.vue?vue&type=template&id=245c535c&scoped=true"
import script from "./enterprise-details.vue?vue&type=script&lang=js"
export * from "./enterprise-details.vue?vue&type=script&lang=js"

import "./enterprise-details.vue?vue&type=style&index=0&id=245c535c&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245c535c"]])

export default __exports__